import { Component, Input, OnInit } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ListaItem } from '../../../_models/lista-item';
import { ProductoFrecuencia } from '../../../_models/producto-frecuencia';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ListaService } from '../../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { ProductoFrecuenciaService } from '../../../_services/producto-frecuencia.service';

@Component( {
  selector: 'app-producto-frecuencia-aliado',
  templateUrl: 'producto-frecuencia-aliado.component.html'
} )

export class ProductoFrecuenciaAliadoComponent implements OnInit {
  @Input() producto: Producto;
  lisFrecuencias: SelectItem[] = [];
  lisFrecuenciasTodos: ListaItem[] = [];
  carInformacionInicial = true;
  lisProductosFrecuencias: ProductoFrecuencia[] = [];
  lisProductosFrecuenciasTodos: ProductoFrecuencia[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  proIgual = false;

  constructor( private proFrecuenciaServicio: ProductoFrecuenciaService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private lisServicio: ListaService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreFrecuenciaProducto', header: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_FRECUENCIA' ), sort: false },
      { field: 'numeroCuotas', header: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_NUMEROCUOTAS' ), sort: false },
      {
        field: 'plazo',
        header: this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_PLAZO' ) + '(' + (this.navServicio.buscarMensaje( 'PRODUCTOFRECUENCIA.LBL_DIAS' )) + ')',
        sort: false
      },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.proFrecuenciaServicio.listadoPorProductoTodos( this.producto.idProducto ), this.lisServicio.getMasterDetails( 'ListasFrecuenciasProductos' ) ).subscribe( ( [ lisProductosFrecuencias, lisFrecuencias ] ) => {
      this.lisFrecuenciasTodos = lisFrecuencias;
      this.lisProductosFrecuenciasTodos = lisProductosFrecuencias.filter( x => x.indicadorAliado );
      this.cargarFormulario();
      this.cargarFrecuenciasProducto();
      this.cargarListadoFrecuencias();
      this.carInformacionInicial = false;
    } );
  }

  cargarListadoFrecuencias() {
    this.lisFrecuencias = [];
    this.lisFrecuenciasTodos.map( ( s: ListaItem ) => {
      this.lisFrecuencias.push( { label: s.nombre, value: s.idLista } );
    } );
  }

  cargarFrecuenciasProducto() {
    this.lisProductosFrecuencias = [];
    this.lisProductosFrecuenciasTodos.map( ( s: ProductoFrecuencia ) => {
      if ( s.indicadorHabilitado ) {
        this.lisProductosFrecuencias.push( s );
      }
    } );
  }


  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoFrecuencia: [ null ],
      idProducto: [ this.producto.idProducto, [ Validators.required ] ],
      idFrecuenciaProducto: [ null, [ Validators.required ] ],
      numeroCuotas: [ null, [ Validators.required, Validators.maxLength( 3 ) ] ],
      plazo: [ null, [ Validators.required, Validators.maxLength( 3 ) ] ],
      indicadorAliado: [ true ],
      indicadorHabilitado: [ true ],
      auditoriaUsuario: [ null ],
      auditoriaFecha: [ null ],
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const frecuencia = this.formulario.value;
      this.validarIgualdad( this.lisProductosFrecuencias, frecuencia );
      if ( !this.proIgual ) {
        const regActualizar = this.lisProductosFrecuenciasTodos.find( x => x.idFrecuenciaProducto == frecuencia.idFrecuenciaProducto && x.numeroCuotas == frecuencia.numeroCuotas && x.plazo == frecuencia.plazo );
        if ( regActualizar ) {
          regActualizar.indicadorHabilitado = true;
          this.proFrecuenciaServicio.actualizar( regActualizar ).subscribe( freActualizada => {
            const d = this.lisProductosFrecuenciasTodos.findIndex( x => x.idProductoFrecuencia === regActualizar.idProductoFrecuencia );
            if ( d ) {
              this.lisProductosFrecuenciasTodos[ d ] = regActualizar;
            }
            this.cargarFrecuenciasProducto();
            this.formulario.reset();
            this.f.idProducto.setValue( this.producto.idProducto );
            this.f.indicadorHabilitado.setValue( true );
            this.f.indicadorAliado.setValue( true );
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 1 );
          }, error => {
            this.guardando = false;
            this.navServicio.setMesage( 3 );
          } );
        } else {
          this.proFrecuenciaServicio.crear( frecuencia ).subscribe( freNueva => {
            frecuencia.idProductoFrecuencia = freNueva.idProductoFrecuencia;
            const d = this.lisFrecuenciasTodos.find( x => x.idLista === frecuencia.idFrecuenciaProducto );
            if ( d ) {
              frecuencia.nombreFrecuenciaProducto = d.nombre;
            }
            this.lisProductosFrecuenciasTodos.push( frecuencia );
            this.cargarFrecuenciasProducto();
            this.formulario.reset();
            this.f.idProducto.setValue( this.producto.idProducto );
            this.f.indicadorHabilitado.setValue( true );
            this.f.indicadorAliado.setValue( true );
            this.submitted = false;
            this.guardando = false;
            this.navServicio.setMesage( 1 );
          }, error => {
            this.guardando = false;
            this.navServicio.setMesage( 3 );
          } );
        }
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_SONIGUALES' )
        } );
        this.guardando = false;
      }
    }
  }

  inhabilitar( proFrecuencia: ProductoFrecuencia ) {
    if ( this.producto.indicadorHabilitado && this.lisProductosFrecuencias.length == 1 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTO.MSG_NOINHABILITAR' )
      } );
    } else {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'frecuencias-aliados',
        accept: () => {
          this.carInformacionInicial = true;
          proFrecuencia.indicadorHabilitado = false;
          this.proFrecuenciaServicio.actualizar( proFrecuencia ).subscribe( regActualizado => {
            const a = this.lisProductosFrecuenciasTodos.findIndex( x => x.idProductoFrecuencia === proFrecuencia.idProductoFrecuencia );
            if ( a >= 0 ) {
              this.lisProductosFrecuenciasTodos[ a ] = proFrecuencia;
            }
            this.cargarFrecuenciasProducto();
            this.navServicio.setMesage(2);
            this.carInformacionInicial = false;
          } );
        },
        reject: () => {
        }
      } );
    }
  }

  validarIgualdad( listado: ProductoFrecuencia[], objComparar: ProductoFrecuencia ) {
    const atrIguales = [ 'idFrecuenciaProducto', 'numeroCuotas', 'plazo' ];
    this.proIgual = listado.find( x => atrIguales.filter( y => x[ y ] == objComparar[ y ] ).length === atrIguales.length ) ? true : false;
  }

}
